'use strict';

module Patersons {

    export interface ForgottenPasswordScope extends ng.IScope {    
        forgottenPasswordDetails: Patersons.ForgottenPasswordDetails;     
        forgottenPasswordForm: ng.IFormController;    
        isTriggered: boolean;  
        validationMessage: string;
        isSmsRequired: boolean;
        errorHandler: any;          
        events: Patersons.ForgottenPasswordCtrl;   
        isBusy: boolean;
        userCompany: UserCompany
    }
    
    export class ForgottenPasswordCtrl {

        scope: Patersons.ForgottenPasswordScope;
        location: ng.ILocationService;
        log: ng.ILogService;
        window: ng.IWindowService;
        state: angular.ui.IStateService;
        stateParams: angular.ui.IStateProvider;
        http: ng.IHttpService;        
        identityService: Patersons.IdentityService;
        tokenService: TokenService;        
        response;
        userCompanyService: UserCompanyService

        static $inject = ['$scope', '$log', '$location', '$window', '$state', '$stateParams', '$http', 'identityService', 'tokenService', 'userCompanyService'];

        constructor($scope, $log, $location, $window, $state, $stateParams, $http, identityService, tokenService, userCompanyService) {
            this.scope = $scope;
            this.location = $location;
            this.window = $window;
            this.state = $state;
            this.stateParams = $stateParams;
            this.http = $http;      
            this.log = $log;
            this.identityService = identityService;  
            this.tokenService = tokenService;  
            this.userCompanyService = userCompanyService

            this.scope.isBusy = false;

            this.scope.isSmsRequired = false;
            this.scope.events = this;         
            this.scope.isTriggered = false; 


            
            this.userCompanyService.getUserCompany().then((company) => {
                this.scope.userCompany = company;
            })
        }  

        save() {
            this.scope.isTriggered = false;
            this.scope.$broadcast('show-errors-check-validity');

            //if (this.response) {
            //    this.verifyResponse(this.response).then((result) => {
                    // Once the token has been verified we can then complete the rest of the process
                    //if (result && result.data && result.data.success == "true") {
                        if (this.scope.forgottenPasswordForm.$invalid) {
                            return;
                        }
                        else {

                            this.scope.isBusy = true;
                            this.identityService.triggerForgottenPassword(this.scope.forgottenPasswordDetails)
                                .then((result) => {
                                    this.state.go('confirmPassword');
                                },
                                (reason) => {
                                    this.log.warn(reason);
                                    if (reason.status == '403') {
                                        this.scope.isSmsRequired = true;
                                    }
                                    if (reason.status == '400') {
                                        this.scope.validationMessage = reason.data.Message;   
                                    }
                                    
                                }
                            ).
                                finally(() => {
                                    this.scope.isBusy = false;
                                });
                        }
                  //  }
            //    });
            //}
        }

        setResponse = function (response) {    
            this.response = response;        
        }

        setWidgetId = function (widgetId) {
            console.info('Created widget ID: %s', widgetId);
            this.scope.widgetId = widgetId;
        };

    }
}
